function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { getCookie } from '../helpers';
var jwt = "";
var myHeaders = new Headers();
var ctHeaders = new Headers();
var depId = '';
var settings;
export var FetchWrapper = {
  init: function init(params) {
    settings = params;
  },
  fetchData: getData,
  fetchEmployees: getEmployees,
  fetchCountries: getCountries,
  fetchDepartment: getDept,
  editEmployee: editUser,
  removeEmployee: removeUser,
  sendInv: sendInvitation,
  resetPassword: resetPassword
};

// get jwt from cookie
// if not, show auth popup and redirect to login page
function getJwt() {
  return new Promise(function (resolve) {
    var cookie = getCookie('OneIdTempCookie');
    if (cookie == "") {
      throw 'Auth_error';
    }
    var cookie_obj = JSON.parse('{"' + decodeURI(cookie).replace(/&/g, '","').replace(/=/g, '":"') + '"}');
    if (cookie_obj.OneIdTokenValue == "" || cookie_obj.OneIdAccessTokenValue == "") {
      throw 'Auth_error';
    }
    resolve(cookie_obj.OneIdAccessTokenValue);
  });
}

// getting data from server first time
function getData() {
  if (settings.debug) console.log('gettin first time data ');
  return getJwt().then(function (data) {
    jwt = data;
    if (settings.debug) console.log('jwt: ', jwt);
    myHeaders.append('Authorization', 'Bearer ' + jwt);
    ctHeaders.append('Authorization', 'Bearer ' + jwt);
    ctHeaders.append('Content-Type', 'application/json');
    return getDept();
  });
}
function getDept() {
  if (settings.debug) console.log('getin dept ');
  return fetch(settings.ApiBaseUrl + '/organizations/admin/me', {
    method: 'GET',
    headers: myHeaders
  }).then(function (response) {
    return resStatus(response);
  }).then(function (data) {
    depId = data.organizations[0].departments[0].id;
    var searchParams = {
      page: 1,
      size: settings.UserListSize,
      search: ''
    };
    return getEmployees(searchParams);
  }).catch(function (error) {
    if (settings.debug) console.log("can't get depid: ", error);
    throw error;
  });
}
function getCountries(_x) {
  return _getCountries.apply(this, arguments);
}
function _getCountries() {
  _getCountries = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(args) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (settings.debug) console.log('gettin countries for iscode ' + settings.CountryCode);
          return _context.abrupt("return", fetch(settings.ApiBaseUrl + '/datalocation/countries?cultureCode=' + settings.CountryCode, {
            headers: myHeaders
          }).then(function (response) {
            return resStatus(response);
          }).catch(function (error) {
            if (settings.debug) console.log("can't get countries: ", error);
            throw error;
          }));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getCountries.apply(this, arguments);
}
function getEmployees(_x2) {
  return _getEmployees.apply(this, arguments);
}
function _getEmployees() {
  _getEmployees = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(args) {
    var params;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (settings.debug) console.log('getin employees ');
          params = args ? '?' + Object.keys(args).map(function (key) {
            return key + '=' + args[key];
          }).join('&') : '';
          if (settings.debug) console.log(params);
          return _context2.abrupt("return", fetch(settings.ApiBaseUrl + '/department/' + depId + '/employees' + params, {
            headers: myHeaders
          }).then(function (response) {
            return resStatus(response);
          }).catch(function (error) {
            if (settings.debug) console.log("can't get employees: ", error);
            throw error;
          }));
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getEmployees.apply(this, arguments);
}
function editUser(_x3, _x4, _x5, _x6) {
  return _editUser.apply(this, arguments);
}
function _editUser() {
  _editUser = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(userId, fname, lname, countrycode) {
    var postBody;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (settings.debug) console.log('countrycode: ', countrycode);
          //TODO REMOVE AFTER DATA LOCATION IS LIVE
          postBody = '';
          if (settings.UseDataLocation) {
            postBody = JSON.stringify({
              "firstName": fname,
              "lastName": lname,
              "middleName": "",
              "countryCode": countrycode
            });
          } else {
            postBody = JSON.stringify({
              "firstName": fname,
              "lastName": lname,
              "middleName": ""
            });
          }
          if (settings.debug) console.log("Edit user body", postBody);
          return _context3.abrupt("return", fetch(settings.ApiBaseUrl + '/person/' + userId, {
            method: 'POST',
            headers: ctHeaders,
            body: postBody
          }).then(function (response) {
            return resStatus(response);
          }).catch(function (error) {
            if (settings.debug) console.log("can't edit user: ", error);
            throw error;
          }));
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _editUser.apply(this, arguments);
}
function removeUser(userId, invitationId) {
  if (settings.debug) console.log('remove cilent: ', userId);
  if (settings.debug) console.log('userid', userId);
  if (settings.debug) console.log('invitationid', invitationId);
  if (userId != null) {
    return fetch(settings.ApiBaseUrl + '/department/' + depId + '/employee/' + userId, {
      method: 'DELETE',
      headers: myHeaders
    }).then(function (response) {
      return resStatus(response);
    }).catch(function (error) {
      if (settings.debug) console.log("can't remove employee: ", error);
      throw error;
    });
  } else {
    if (settings.debug) console.log('Calling for deleting invitation', invitationId);
    return fetch(settings.ApiBaseUrl + '/department/' + depId + '/invitation/' + invitationId, {
      method: 'DELETE',
      headers: myHeaders
    }).then(function (response) {
      return resStatus(response);
    }).catch(function (error) {
      if (settings.debug) console.log("can't remove invitation: ", error);
      throw error;
    });
  }
}
function getHeaders() {
  var headers = new Headers();
  headers.append('Content-Type', 'application/json');
  return headers;
}
function resetPassword(email, loggedIn) {
  if (settings.debug) console.log('reset password for: ', email);
  return fetch(settings.ApiBaseUrl + '/passwordreset', {
    method: 'POST',
    headers: loggedIn ? ctHeaders : getHeaders(),
    body: JSON.stringify({
      "email": email,
      "tenant": settings.TenantName + '.' + settings.TenantDomain,
      "redirectUrl": settings.RedirectUrl,
      "redirectUrn": "",
      "emailRedirectUrn": "",
      "clientId": settings.ClientId,
      "cultureCode": settings.CultureCode,
      "state": settings.LoginUrl
    })
  }).then(function (response) {
    return resStatus(response);
  }).catch(function (error) {
    if (settings.debug) console.log("can't reset password: ", error);
    throw error;
  });
}
function sendInvitation(emails) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }
  if (settings.debug) console.log('sending invitation ', emails, params);
  var promises = emails.map(function (email) {
    return fetch(settings.ApiBaseUrl + '/department/' + depId + '/invitation', {
      method: 'POST',
      headers: ctHeaders,
      body: JSON.stringify({
        "email": email,
        "tenant": settings.TenantName + '.' + settings.TenantDomain,
        "redirectUrl": settings.RedirectUrl,
        "redirectUrn": "",
        "emailRedirectUrn": "",
        "clientId": settings.ClientId,
        "cultureCode": settings.CultureCode,
        "state": settings.PostRegisterPageUrl,
        "parameters": {
          "MESSAGE_DEFAULT": params[0],
          "MESSAGE_PERSONAL": params[1]
        }
      })
    }).then(function (response) {
      return resStatus(response);
    }).catch(function (error) {
      if (settings.debug) console.log("can't send inv: ", error);
      throw error;
    });
  });
  return Promise.all(promises);
}
function resStatus(response) {
  if (settings.debug) console.log(response);
  if (response.status === 401) {
    // show authorize popup
    throw 'Auth_error';
  }
  if (response.status >= 200 && response.status <= 204) {
    return response.text().then(function (text) {
      return text ? JSON.parse(text) : {};
    });
  }
  throw "Server_error";
}